import { render, staticRenderFns } from "./geekpay.vue?vue&type=template&id=0c61ae6a&scoped=true&"
import script from "./geekpay.vue?vue&type=script&lang=js&"
export * from "./geekpay.vue?vue&type=script&lang=js&"
import style0 from "./geekpay.vue?vue&type=style&index=0&id=0c61ae6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c61ae6a",
  null
  
)

export default component.exports